import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-intropage',
  templateUrl: './intropage.component.html',
  styleUrls: ['./intropage.component.css']
})
export class IntropageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
